import {
  PageData,
  PageReference,
  SearchResult,
} from "../../types/InfoWebTypes";

export default class InfoWebCoreApi {
  private static apiUrl = "https://omaliittyma.lomarengas.fi/infowebapi";
  private static apiToken = "ZBv3Lo6gQkC1vQ25YA2nWzHpi7xGQ";
  private static timeoutInSeconds = 5;
  private static cacheDurationInMinutes = 5;

  public static async GetPagesAsync(
    language: string,
  ): Promise<PageReference[]> {
    const data = await this.FetchAsync(`getPages/${language}`, true);
    return data as PageReference[];
  }

  public static async GetPageByPathAsync(path: string): Promise<PageData> {
    const data = await this.FetchAsync(`getPageByPath?path=${path}`, true);
    return data as PageData;
  }

  public static async SearchAsync(
    language: string,
    startPageId: string,
    q: string,
  ): Promise<SearchResult[]> {
    return await this.FetchAsync(
      `search/${language}/${startPageId}?q=${q}`,
      false,
    );
  }

  private static async FetchAsync(
    endPoint: string,
    allowCaching: boolean,
  ): Promise<any> {
    var json = null;

    if (allowCaching) {
      var expiration = sessionStorage.getItem(endPoint + "_expires");

      if (expiration) {
        if (new Date(expiration) < new Date()) {
          sessionStorage.removeItem(endPoint);
        }
      }

      json = sessionStorage.getItem(endPoint);
    }

    if (!json) {
      const controller = new AbortController();
      setTimeout(() => controller.abort(), this.timeoutInSeconds * 1000);

      if (process.env.REACT_APP_INFOWEB_API_URL) {
        this.apiUrl = process.env.REACT_APP_INFOWEB_API_URL;
      }

      if (process.env.REACT_APP_INFOWEB_API_AUTH) {
        this.apiToken = process.env.REACT_APP_INFOWEB_API_AUTH;
      }

      try {
        const response = await fetch(`${this.apiUrl}/${endPoint}`, {
          signal: controller.signal,
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: this.apiToken,
          },
        });

        if (response.ok) {
          json = await response.text();

          if (allowCaching) {
            sessionStorage.setItem(endPoint, json);
            sessionStorage.setItem(
              endPoint + "_expires",
              new Date(
                new Date().getTime() + this.cacheDurationInMinutes * 60000,
              ).toString(),
            );
          }
        } else {
          console.error(
            `InfoWebCoreApi.Query: ${endPoint} ${response.status} ${response.statusText}`,
          );
        }
      } catch (e) {
        console.error(`InfoWebCoreApi.Query: ${e}`);
      }
    }

    if (json) {
      var responseData = JSON.parse(json);
      return responseData;
    }

    return null;
  }
}
